import type { OrderSummary } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { OrderFlagBadge } from './order-flag-badge';
import { OrderStatusBadge } from './order-status-badge';

interface OrderStatusListProps {
  readonly order: Pick<
    OrderSummary,
    'status' | 'fulfillmentStatus' | 'pendingCancelRequest' | 'displayStatus' | 'badges'
  >;
}

/** 주문 상태와 처리 필요 배지를 한 줄로 — "주문 상태" 목록으로 읽힌다(상세 머리말). */
export const OrderStatusList = ({ order }: OrderStatusListProps): ReactElement => (
  <ul aria-label="주문 상태" className="flex flex-wrap items-center gap-1.5">
    <li>
      <OrderStatusBadge order={order} />
    </li>
    {order.badges.map((badge) => (
      <li key={badge}>
        <OrderFlagBadge badge={badge} />
      </li>
    ))}
  </ul>
);
